module.exports = __webpack_public_path__ + "x5.no1.d9ff5961.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/x5.no1.jpg
// module id = vRXt
// module chunks = 0